import React from 'react';
import styled from 'styled-components';
import { PreviewContainer } from './richTextEditor.styled';
import DOMPurify from 'dompurify';

interface HtmlPreviewerProps {
  html: string;
  className?: string;
}

const HtmlPreviewer: React.FC<HtmlPreviewerProps> = ({ html, className }) => {
  return (
    <PreviewContainer
      className={className}
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html || '') }}
    />
  );
};

export default HtmlPreviewer;
